/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gray_Lush_Lynx_DashInputs */

const en_gray_lush_lynx_dash = /** @type {(inputs: Gray_Lush_Lynx_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back`)
};

const de_gray_lush_lynx_dash = /** @type {(inputs: Gray_Lush_Lynx_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück`)
};

/**
* | output |
* | --- |
* | "Back" |
*
* @param {Gray_Lush_Lynx_DashInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gray_lush_lynx_dash = /** @type {((inputs?: Gray_Lush_Lynx_DashInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gray_Lush_Lynx_DashInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gray_lush_lynx_dash(inputs)
	return de_gray_lush_lynx_dash(inputs)
});